export default __webpack_public_path__ + "static/media/clip-rounded-header-bottom.3e23263d.svg";